import { useFilterSearchParams } from "@/utils/hooksUtils";
import { useState } from "react";
import { CertificateVehicleColor } from "../types";
import { VehicleColorFilterForm } from "./forms/VehicleColorFilterForm";
import { VehicleColorForm } from "./forms/VehicleColorForm";
import { VehicleColorTable } from "./tables/VehicleColorTable";

export const VehicleColorTabView = () => {
  const [colorFormOpen, setColorFormOpen] = useState<boolean>(false);
  const [colorToUpdate, setColorToUpdate] = useState<CertificateVehicleColor>();

  const searchParams = useFilterSearchParams();

  const handleCreateClick = () => {
    setColorFormOpen(true);
  };

  const handleUpdateClick = (category: CertificateVehicleColor) => {
    setColorFormOpen(true);
    setColorToUpdate(category);
  };

  const handleFormCancel = () => {
    setColorFormOpen(false);
    setColorToUpdate(undefined);
  };

  return (
    <div>
      <VehicleColorFilterForm searchParams={searchParams} onCreateClick={handleCreateClick} />

      <VehicleColorTable searchParams={searchParams} onUpdateClick={handleUpdateClick} />

      <VehicleColorForm color={colorToUpdate} open={colorFormOpen} onFormCancel={handleFormCancel} />
    </div>
  );
};
